const isPrerenderCrawler = () => {
  return navigator.userAgent.includes('Prerender');
};

export default isPrerenderCrawler;
